export class DatabaseOrgDataService {
	private id: string | undefined = undefined;

	updateOrgId(id: string) {
		this.id = id;
	}

	getId() {
		return this.id;
	}
}
